import numeral from "numeral";

import { formatCurrency } from "../cryptoformat";

export const basisPointsToDisplayPercentage = (basisPoints: number) => {
  const BASIS_POINT_TO_PERCENTAGE = 0.0001;
  const asDecimal = basisPoints * BASIS_POINT_TO_PERCENTAGE;

  return numeral(asDecimal).format("0.[0]%");
};

/**
 * Return a "0" value in the current currency with correct symbol, e.g. "£0.00"
 *
 * This fills the gap of #calculatePriceOrBalance() which does not let
 * zero values pass through naturally
 * @param currency e.g. GBP
 * @param decimalPlaces e.g. 2
 * @returns Uses the correct symbol and symbol placement for each currency
 * e.g. GBP = "£0.00", JPY = "¥0.00", ETH = "Ξ0.00"
 */
export const zeroValueCurrency = (currency: string, decimalPlaces = 0) => {
  return formatCurrency(0, currency, "en", false, {
    decimalPlaces,
  });
};
